import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// 引入组件
import store from "./stateStore";


import login from "../../components/login";
import index from "../../components/index";


// 要告诉 vue 使用 vueRouter

const routes = [
  {
    path: "/index",
    component:index,
    name :"首页",
    children:[
      {
        path: "/",
        component: () => import('@/components/section/index'),
        name: "部门管理"
      },
      {
        path: "/staff",
        component: () => import('@/components/staff/index'),
        name: "员工管理"
      },
      {
        path: "/vacation",
        component: () => import('@/components/vacation/index'),
        name: "休假设置"
      },
      {
        path: "/section",
        component: () => import('@/components/section/index'),
        name: "部门管理"
      },
      {
        path: "/position",
        component: () => import('@/components/position/index'),
        name: "职位管理"
      },
      {
        path: "/app",
        component: () => import('@/components/app/index'),
        name: "APP账号管理"
      },
      {
        path: "/terminal",
        component: () => import('@/components/terminal/index'),
        name: "终端账号管理"
      },
      {
        path: "/sop",
        component: () => import('@/components/sop/index'),
        name: "公司制度"
      },
      {
        path: "/check",
        component: () => import('@/components/check/index'),
        name: "考勤记录"
      },
      {
        path: "/payment",
        component: () => import('@/components/payment/index'),
        name: "支付申请"
      },
      {
        path: "/workSite",
        component: () => import('@/components/workSite/index'),
        name: "办公地点"
      },
      {
        path: "/staffSet",
        component: () => import('@/components/staffSet/index'),
        name: "员工打卡地点"
      },
      {
        path: "/applyFor",
        component: () => import('@/components/applyFor/index'),
        name: "申请记录"
      },
      {
        path: "/system",
        component: () => import('@/components/system/index'),
        name: "学习园地"
      },
      {
        path: "/notice",
        component: () => import('@/components/notice/index'),
        name: "公告管理"
      },
      {
        path: "/holiday",
        component: () => import('@/components/holiday/index'),
        name: "假期设置"
      },
      {
        path: "/OKRManagement",
        component: () => import('@/components/OKRManagement/index'),
        name: "OKR管理"
      },
    ]
  },
  {
    path: "/login",
    component: login,
    name: "登录页面"
  },
  {
    path: "/websocket",
    component: () => import('@/components/websocket/index'),
    name: "登录页面"
  }
]

let router =  new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if(store.state.userInfo==null && to.path != '/login' && to.path != '/websocket'){
    //读取本地存储值。
    let userInfoStr = sessionStorage.getItem("userInfo");
    if(userInfoStr== null){
      router.push("/login");
      return;
    }
    let userInfoObject = JSON.parse(userInfoStr);
    store.commit("setUserInfo",userInfoObject);
  }
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/assets/js/route.js